import { questionnaireInstanceIdSchema } from "@repo/api/schemas";
import { createFileRoute } from "@tanstack/react-router";
import { QuestionnaireFillPage } from "@/features/questionnaires";
export const Route = createFileRoute("/_consented/questionnaires_/$id")({ component: Page });
function Page() {
  const id = questionnaireInstanceIdSchema.parse(Route.useParams().id);
  return <QuestionnaireFillPage key={id} id={id} />;
}
